import { render, staticRenderFns } from "./OffersListCard.vue?vue&type=template&id=2b470437&scoped=true&"
import script from "./OffersListCard.vue?vue&type=script&lang=js&"
export * from "./OffersListCard.vue?vue&type=script&lang=js&"
import style0 from "./OffersListCard.vue?vue&type=style&index=0&id=2b470437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b470437",
  null
  
)

export default component.exports